import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Bank from "../../components/kyc/Bank";
import BillingAddressKyc from "../../components/kyc/BillingAddressKyc";
import Pan from "../../components/kyc/Pan";
import { getkycDetailsApi } from "../../redux/features/kycDetailsSlice";
import { FaRegCheckCircle } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import { getProfileApi } from "../../redux/features/profileSlice";
import { toast } from "react-toastify";
import { IoInformationCircleOutline } from "react-icons/io5";
import { IconButton, Tooltip } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";

const KYC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { panDetails, billingAddress, bankAccDetails, adhaarDetails } = t(
    "profileSettingPage.kycTab"
  );

  const Token = sessionStorage.getItem("token");

  useEffect(() => {
    GetAddressKycAPI();
  }, []);

  const [addressApiData, setAddressApiData] = useState("");
  const GetAddressKycAPI = async () => {
    try {
      // const url = `${process.env.REACT_APP_BASE_URL}/address/get_address`;
      // const headers = {
      //   "Content-Type": "application/json",
      //   Accept: "application/json",
      //   Authorization: `Bearer ${Token}`,
      // };

      // const response = await fetch(url, {
      //   method: "GET",
      //   headers: headers,
      // });

      // const data = await response.json();

      const res = await axiosInstance.get("/address/get_address");
      const { data, error, message } = res.data || {};

      if (!error) {
        const { name, line1, line2, state, city, zip, mobileNumber } =
          data?.[0] || [];
        // data?.data[data.data.length - 1] || [];
        setAddressApiData(zip);
      }
    } catch (error) {
      console.error("ERROR IN CATCH+++++++++++++++++", error);
    }
  };

  const kycDetailApiResponse = useSelector(
    (state) => state.kycDetailsSlice.data.data
  );
  const profileApiResponse = useSelector(
    (state) => state.profileSlice.data.data
  );

  const { state, city, zip, _id } =
    profileApiResponse?.[0]?.billAddressUser || {};

  const { pan_no, account_no, adhar_no } = profileApiResponse?.[0]?.kyc || {};

  const { PanNumber, dob, email, Name, NameOnTheCard, STATUS } =
    kycDetailApiResponse?.[0]?.pan?.msg || {};
  // const { account_no } = kycDetailApiResponse?.[0]?.bank?.msg || {};

  useEffect(() => {
    dispatch(getkycDetailsApi());
    dispatch(getProfileApi());
  }, [dispatch]);

  const [expanded, setExpanded] = useState("panel1");

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    if ((panel === "panel2" || panel === "panel3") && !PanNumber) {
      toast.error("Please fill PAN details first");
      return;
    }

    setExpanded(isExpanded ? panel : false);
  };

  // const handleAccordionChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  const handleNext = (nextPanel) => {
    setExpanded(nextPanel);
  };
  return (
    <section id="KYC">
      <div className="row">
        {/* PAN DETAILS Accordion */}
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleAccordionChange("panel1")}
          className="mb-4"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src="/images/profile.png" width={40} alt="profile" />
                <span className="p-2">{panDetails}</span>
              </div>
              <div>
                {PanNumber ? (
                  <FaRegCheckCircle color="green" size={30} />
                ) : (
                  <MdErrorOutline color="red" size={30} />
                )}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Pan
              kycDetailApiResponse={kycDetailApiResponse}
              handleNext={handleNext}
            />
          </AccordionDetails>
        </Accordion>
        {/* BILLING ADDRESS Accordion */}
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleAccordionChange("panel2")}
          className="mb-4"
          // sx={{ pointerEvents: !PanNumber ? "none" : "auto" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/images/billing_logo.png"
                  width={40}
                  alt="billing_address"
                />
                <span className="p-2">{billingAddress}</span>
              </div>
              <div>
                {addressApiData ? (
                  <FaRegCheckCircle color="green" size={30} />
                ) : (
                  <MdErrorOutline color="red" size={30} />
                )}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <BillingAddressKyc
              handleNext={handleNext}
              GetAddressKycAPI={GetAddressKycAPI}
              kycDetailApiResponse={kycDetailApiResponse}
            />
          </AccordionDetails>
        </Accordion>
        {/* BANK DETAILS Accordion */}
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleAccordionChange("panel3")}
          className="mb-4"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <img
                  src="/images/bank_account_icon.png"
                  width={40}
                  alt="bank"
                />
                <span className="p-2">{bankAccDetails} </span>
                <Tooltip title="This will be the sole account for all the transactions (be it buying or selling).">
                  <IconButton>
                    <IoInformationCircleOutline />
                  </IconButton>
                </Tooltip>
              </div>
              <div>
                {account_no ? (
                  <FaRegCheckCircle color="green" size={30} />
                ) : (
                  <MdErrorOutline color="red" size={30} />
                )}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <Bank kycDetailApiResponse={kycDetailApiResponse} />
          </AccordionDetails>
        </Accordion>
      </div>
    </section>
  );
};

export default KYC;
